export interface Product {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'subscription' | 'payment';
  price: string;
  durationMonths: number;
}

export const products: Product[] = [
  {
    id: 'prod_SYKxBA1icAgOoz',
    priceId: 'price_1RtW9TB0B3nriuwYUyIoSbfp',
    name: 'Básico',
    description: '(30 dias) Gerenciamento de 1 grupo - Até 30 jogadores - Sorteio de times - Financeiro - Relatórios',
    mode: 'subscription',
    price: 'R$ 50,00',
    durationMonths: 1
  },
  {
    id: 'prod_SCkJNLCwrTtoEC',
    priceId: 'price_1RtW7UB0B3nriuwYofTFEbYJ',
    name: 'Profissional',
    description: '(12 meses - Cobrança mensal) Gerenciamento de mais de até 2 grupos - Até 50 jogadores por Grupo - Sorteio de times - Financeiro - Relatórios - Resenha - Criar Jogos',
    mode: 'subscription',
    price: 'R$ 80,00',
    durationMonths: 12
  },
  {
    id: 'prod_SCkLtyiYuAizwO',
    priceId: 'price_1RtW0mB0B3nriuwY1nJcHogh',
    name: 'Premium',
    description: '(12 meses - Cobrança mensal) - Gerenciamento para mais de 2 grupos - Até 100 jogadores por grupo - Sorteio de times - Financeiro - Relatórios - Resenha - Criar Jogos - Suporte prioritário',
    mode: 'subscription',
    price: 'R$ 100,00',
    durationMonths: 12
  }
];